<div class="titolo-dialog">
  <h2 mat-dialog-title style="font-size: 25px">Configurazione risposte Assessment</h2>
  <a>{{ data.titolo }}</a>
</div>

<div mat-dialog-content class="dialog-center-cont">
  <ng-scrollbar #scrollDialog>
    <div style="height: 10px"></div>

    <!-- ---------------------------------------- B U O N E  P R A T I C H E  ------------------------- -->
    @if (data.elemento === 'azione') {
      <div class="cont-dd" appFormContainer [larghezza]="2">
        <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
          <div class="cont-titolo">
            <mat-label class="titolo">Buone Pratiche Selezionate</mat-label>
            <div>
              <button
                mat-flat-button
                class="imp-esclud"
                color="accent"
                (click)="apriFiltroSelezionati('azione')"
                matBadgeColor="warn"
              >
                <mat-icon matSuffix>filter_list</mat-icon>
                Filtri
              </button>
            </div>
          </div>
          <ng-scrollbar #scrollSelezionate>
            <div
              scrollViewport
              dropListScroller
              cdkDropList
              #selListAzioni="cdkDropList"
              [cdkDropListData]="arrayAzioneBPSel"
              [cdkDropListConnectedTo]="[dispListAzioniBP]"
              class="list"
              (cdkDropListDropped)="dropAzioneBP($event)"
            >
              <div class="nessun-elemento" *ngIf="!arrayAzioneBPSel?.length && !loadingDisponibili">
                <p>Nessun azione o buona pratica selezionata</p>
              </div>

              <div
                class="box"
                *ngFor="let sel of arrayAzioneBPSelFiltrati"
                cdkDrag
                [matTooltip]="sel.descrizione"
              >
                <div class="box-sx">
                  <button mat-icon-button title="Sposta" aria-label="Sposta">
                    <mat-icon> drag_handle </mat-icon>
                  </button>
                  <mat-label class="truncate">{{ sel.titolo }}</mat-label>
                </div>
              </div>
            </div>
          </ng-scrollbar>
        </div>
        <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
          <div class="cont-titolo">
            <mat-label class="titolo">Buone Pratiche Disponibili</mat-label>
            <div>
              <button
                mat-flat-button
                class="imp-esclud"
                color="accent"
                (click)="apriFiltro('azione')"
                matBadgeColor="warn"
              >
                <mat-icon matSuffix>filter_list</mat-icon>
                Filtri
              </button>
            </div>
          </div>
          <ng-scrollbar #scrollDisponibili>
            <div
              cdkDropList
              scrollViewport
              dropListScroller
              #dispListAzioniBP="cdkDropList"
              [cdkDropListData]="arrayAzioneBP"
              [cdkDropListConnectedTo]="[selListAzioni]"
              class="list"
              style="background-color: #f5f5f5"
              (cdkDropListDropped)="dropAzioneBP($event)"
            >
              <div class="elemento-disp" *ngIf="loadingDisponibili">
                <mat-spinner style="height: 50px"></mat-spinner>
              </div>

              <div class="nessun-elemento" *ngIf="!arrayAzioneBP?.length && !loadingDisponibili">
                <p>Nessun azione o buona pratica Disponibile</p>
              </div>

              <div
                class="box"
                style="background-color: #f5f5f5"
                *ngFor="let disp of arrayAzioneBP"
                cdkDrag
                [matTooltip]="disp.descrizione"
              >
                <div class="box-sx">
                  <button mat-icon-button title="Sposta" aria-label="Sposta">
                    <mat-icon> drag_handle </mat-icon>
                  </button>
                  <mat-label class="truncate">{{ disp.titolo }}</mat-label>
                </div>
              </div>
            </div>
          </ng-scrollbar>
        </div>
      </div>
    }

    <!-- ---------------------------------------- K P I  ------------------------- -->
    @if (data.elemento === 'kpi') {
      <div class="cont-dd" appFormContainer [larghezza]="2">
        <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
          <div class="cont-titolo">
            <mat-label class="titolo">KPI Selezionati</mat-label>
            <div>
              <button
                mat-flat-button
                class="imp-esclud"
                color="accent"
                (click)="apriFiltroSelezionati('kpi')"
                matBadgeColor="warn"
              >
                <mat-icon matSuffix>filter_list</mat-icon>
                Filtri
              </button>
            </div>
          </div>
          <ng-scrollbar #scrollSelezionate>
            <div
              scrollViewport
              dropListScroller
              cdkDropList
              #selListKpi="cdkDropList"
              [cdkDropListData]="arrayKpiSel"
              [cdkDropListConnectedTo]="[dispListKpi]"
              class="list"
              (cdkDropListDropped)="dropKpi($event)"
            >
              <div class="nessun-elemento" *ngIf="!arrayKpiSel?.length && !loadingDisponibili">
                <p>Nessun KPI selezionato</p>
              </div>

              <div
                class="box"
                *ngFor="let sel of arrayKpiSelFiltrati"
                cdkDrag
                [matTooltip]="sel.descrizione"
              >
                <div class="box-sx">
                  <button mat-icon-button title="Sposta" aria-label="Sposta">
                    <mat-icon> drag_handle </mat-icon>
                  </button>
                  <mat-label class="truncate">{{ sel.descrizione }}</mat-label>
                </div>
              </div>
            </div>
          </ng-scrollbar>
        </div>
        <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
          <div class="cont-titolo">
            <mat-label class="titolo">KPI Disponibili</mat-label>
            <div>
              <button
                mat-flat-button
                class="imp-esclud"
                color="accent"
                (click)="apriFiltro('kpi')"
                matBadgeColor="warn"
              >
                <mat-icon matSuffix>filter_list</mat-icon>
                Filtri
              </button>
            </div>
          </div>
          <ng-scrollbar #scrollDisponibili>
            <div
              cdkDropList
              scrollViewport
              dropListScroller
              #dispListKpi="cdkDropList"
              [cdkDropListData]="arrayKpi"
              [cdkDropListConnectedTo]="[selListKpi]"
              class="list"
              style="background-color: #f5f5f5"
              (cdkDropListDropped)="dropKpi($event)"
            >
              <div class="elemento-disp" *ngIf="loadingDisponibili">
                <mat-spinner style="height: 50px"></mat-spinner>
              </div>

              <div class="nessun-elemento" *ngIf="!arrayKpi?.length && !loadingDisponibili">
                <p>Nessun KPI Disponibile</p>
              </div>

              <div
                class="box"
                style="background-color: #f5f5f5"
                *ngFor="let disp of arrayKpi"
                cdkDrag
                [matTooltip]="disp.descrizione"
              >
                <div class="box-sx">
                  <button mat-icon-button title="Sposta" aria-label="Sposta">
                    <mat-icon> drag_handle </mat-icon>
                  </button>
                  <mat-label class="truncate">{{ disp.descrizione }}</mat-label>
                </div>
              </div>
            </div>
          </ng-scrollbar>
        </div>
      </div>
    }
    @if (data.isVsme) {
      <app-separatore-label
        [titoloSeparatore]="
          'Riepilogo ' +
          (data.elemento === 'kpi'
            ? 'dei KPIs selezionati'
            : 'delle Azioni buone pratiche selezionate')
        "
        [styleSeparatore]="'medium'"
      >
      </app-separatore-label>
    } @else {
      <app-separatore-label
        [titoloSeparatore]="
          'Compila il punteggio per ' +
          (data.elemento === 'kpi' ? 'i KPIs selezionati' : 'le Azioni buone pratiche selezionate')
        "
        [styleSeparatore]="'medium'"
      >
      </app-separatore-label>
    }

    <!--  <div style="height: 20px;"></div> -->

    @if (arrayKpiSel.length > 0) {
      <div class="cont-punteggio">
        @for (elemSel of arrayKpiSel; track elemSel.id) {
          <div class="cont-elem-punteggio">
            <div>
              <div class="elemento-titolo">{{ elemSel.descrizione }}</div>
              <div class="elemento-descrizione">{{ elemSel.nomeBreve }}</div>
            </div>

            @if (!data.isVsme) {
              <div class="mat-form-field-punteggio">
                <mat-form-field (mousedown)="$event.stopPropagation()">
                  <mat-label>Punteggio se compilato</mat-label>
                  <input
                    matInput
                    placeholder="Punteggio se compilato"
                    type="number"
                    appInputNumber
                    [value]="elemSel.valoreAttribuito"
                    [(ngModel)]="elemSel.valoreAttribuito"
                  />
                  <mat-error appFormError></mat-error>
                </mat-form-field>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (arrayAzioneBPSel.length > 0) {
      <div class="cont-punteggio">
        @for (elemSel of arrayAzioneBPSel; track elemSel.id) {
          <div class="cont-elem-punteggio">
            <div>
              <div class="elemento-titolo">{{ elemSel.titolo }}</div>
              <div class="elemento-descrizione">{{ elemSel.descrizione }}</div>
            </div>

            @if (!data.isVsme) {
              <div class="mat-form-field-punteggio">
                <mat-form-field (mousedown)="$event.stopPropagation()">
                  <mat-label>Punteggio se compilato</mat-label>
                  <input
                    matInput
                    placeholder="Punteggio se compilato"
                    type="number"
                    appInputNumber
                    [value]="elemSel.valoreAttribuito"
                    [(ngModel)]="elemSel.valoreAttribuito"
                  />
                  <mat-error appFormError></mat-error>
                </mat-form-field>
              </div>
            }
          </div>
        }
      </div>
    }

    <div style="height: 10px"></div>
  </ng-scrollbar>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
